import { IActivities } from './activities';

export enum UserInfoActivitiesType {
  Global = 'Global',
  Organization = 'Organization',
  User = 'User'
}

export interface IUserInfoActivities extends IUserInfoScope {
  activities: IActivities;
}

export interface IUserInfoScope {
  id: string | null;
  type: UserInfoActivitiesType;
}

export interface IUserInfo {
  userId: string;
  userName: string;
  firstName: string;
  lastName: string;
  fullName: string;
  emailAddress: string | null;
  phoneNumber?: string | null;
  primaryOrganizationId: string;
  primaryOrganizationName: string;
  activities: IUserInfoActivities[];
}
